import { Fragment } from "react";
import { Link } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../primitives/breadcrumb";

export interface SettingsCrumb {
  label: string;
  /** Omitted for the current page, which renders as plain (non-link) text. */
  to?: string;
}

/**
 * The wayfinding trail for a settings sub-page nested below its tab row
 * (product-owner decision, 12 Sep,
 * docs/features/cost-engine-productionisation/03_manufacturing_surfaces_design.md
 * "IA — Manufacturing nests under Settings › Catalogue as Live costing"):
 * every settings sub-page shows "Settings › Catalogue › Live costing ›
 * Manufacturing setup › 5351 5COLXL75LEUV" rather than a "Back to …" link, so
 * every ancestor stays one click away instead of only the immediate parent.
 */
export function SettingsBreadcrumbs({ crumbs }: { crumbs: SettingsCrumb[] }) {
  return (
    <Breadcrumb>
      <BreadcrumbList className="flex-nowrap overflow-x-auto">
        {crumbs.map((crumb, index) => (
          <Fragment key={`${index}-${crumb.label}`}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem className="whitespace-nowrap">
              {crumb.to ? (
                <BreadcrumbLink asChild>
                  <Link to={crumb.to}>{crumb.label}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
